import { onError } from "@apollo/client/link/error";
import { toast } from "../toast";

// Suppress only minor validation/usage noise; toast all other errors
const SUPPRESS_CODES = new Set([
  "GRAPHQL_VALIDATION_FAILED",
  "BAD_USER_INPUT",
]);
const MISSING_VAR_RE = /Variable \".*\" of required type \".*!\" was not provided/;

// Simple dedupe to avoid toast spam for repeated messages
let lastToast = { msg: null, ts: 0 };
const DEDUPE_MS = 5000;

function shouldToastGraphQLError(err) {
  const code = err?.extensions?.code;
  const msg = err?.message ?? "GraphQL error occurred";

  // Suppress known minor validation messages
  if (SUPPRESS_CODES.has(code)) return false;
  if (MISSING_VAR_RE.test(msg)) return false;

  // Suppress getStaffByEmailId null error (just console.log it)
  if (msg.includes("Cannot return null for non-nullable field Query.getStaffByEmailId")) {
    return false;
  }

  // Toast for all other GraphQL errors
  return true;
}

function dedupedToast(message, prefix = "Error") {
  const now = Date.now();
  if (lastToast.msg === message && now - lastToast.ts < DEDUPE_MS) {
    return; // skip duplicate toast within window
  }
  lastToast = { msg: message, ts: now };
  toast.error(`${prefix}: ${message}`);
}

// Global GraphQL + network error handler - console.log only, no toasts
export const apolloErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
    graphQLErrors.forEach((err) => {
      const message = err?.message ?? "GraphQL error occurred";
      const code = err?.extensions?.code;
      // eslint-disable-next-line no-console
      console.log("GRAPHQL ERROR:", message, code ? `(code: ${code})` : "");
      // Toast notifications disabled - errors only logged to console
    });
  }

  if (networkError) {
    const message = networkError?.message ?? "Network error occurred";
    // eslint-disable-next-line no-console
    console.log("NETWORK ERROR:", message);
    // Toast notifications disabled - errors only logged to console
  }
});
